import { render } from "./metrics-row.vue?vue&type=template&id=1aff45a1"
import script from "./metrics-row.vue?vue&type=script&lang=js"
export * from "./metrics-row.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__